import React, { useEffect, useState } from 'react'
import TableComponent from 'components/Table'
import { CreditRowItem } from '../../CreditRowItem'
import { Collapse, Col } from 'antd'

import { MinusSmallIco, PlusSmallIco } from '../../../../../../modules/CustomIcons'
import { useTranslation } from 'react-i18next'

const ClosedTableList = (props: any) => {
  const {t} = useTranslation()
  const { Panel } = Collapse
  return (
    <div className={'creditCollapseBox'} style={{ display: "block" }}>
      <Collapse
        accordion
        expandIconPosition={'end'}
        className={'creditCollapse depositCollapse'}
        ghost
        defaultActiveKey={props.defaultActiveKey}
        expandIcon={() => (
          <div className={'creditCollapse__iconBox'}>
            {props.panel ? <MinusSmallIco /> : <PlusSmallIco />}
          </div>
        )}
        onChange={props.onClosePanel}
      >
        <Panel className={'depositListPanel'} header={t("deposit.closedDeposits")} key="1" extra={<div className={'line'} />}>
          <TableComponent
            columns={props.columns}
            className="credit-table depositTable credit-table-panel transfer-table salary-table  home_account_opt_table closedDepositTable"
            // className="credit-table depositTable depositTable__panel"
            onRow={props.onRow}
            rowClassName={(record: any, index: number) =>
              index % 2 === 0 ? 'table-row-dark' : 'table-row-light'
            }
            data={props.data}
            scroll={{ x: 1000 }}
            pagination={false}
            rowSelection={false}
            pageSize={3}
            // onChange={handleChange}
            ellipsis
            expandedRowKeys={props.expandedRowKeys}
            onExpand={props.onExpand}
            expandable={{
              expandedRowRender: (record: any) => {
                return (
                  <CreditRowItem
                    // styleCreditRowColumLeft={{ marginLeft: 80 }}
                    leftItems={record}
                    styleCreditRowColum={{
                      position: 'relative',
                      right: 15,
                    }}
                    handleRowClose={props.handleRowClose}
                    labelStyle={'depositTable__panelLabel'}
                    tableData={record}
                  />
                )
              },
              // rowExpandable: record => {
              //   if (props.firstRow) {
              //     return false;
              //   } else {
              //     return true;
              //   }
              // },
              expandRowByClick: true,
              expandIconColumnIndex: -1,
              showExpandColumn: false,
              // expandIcon: () => null
            }}
          />
        </Panel>
      </Collapse>
    </div>
  )
}
export default ClosedTableList